export default "__VITE_ASSET__S5NZe1Dd__"